"use client";

import * as React from "react";
import { cn } from "@/utils/utils";
import { SectionCard, CardTitle } from "@/src/components";

export interface PropDefinition {
  name: string;
  type: string;
  default?: string;
  description: string;
  required?: boolean;
}

export interface PropsTableProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Array of prop definitions */
  props: PropDefinition[];
  /** Title override */
  title?: string;
}

export function PropsTable({
  props,
  title = "Props",
  className,
  ...rest
}: PropsTableProps) {
  return (
    <SectionCard
      header={<CardTitle>{title}</CardTitle>}
      contentClassName="p-0"
      className={className}
      {...rest}
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/30">
              <th className="text-left py-3 px-4 font-semibold">Prop</th>
              <th className="text-left py-3 px-4 font-semibold">Type</th>
              <th className="text-left py-3 px-4 font-semibold">Default</th>
              <th className="text-left py-3 px-4 font-semibold">Description</th>
            </tr>
          </thead>
          <tbody>
            {props.map((prop) => (
              <tr key={prop.name} className="border-b last:border-b-0">
                <td className="py-3 px-4">
                  <code className="font-mono text-xs bg-muted px-1.5 py-0.5 rounded">
                    {prop.name}
                    {prop.required && (
                      <div className="text-destructive ml-0.5">*</div>
                    )}
                  </code>
                </td>
                <td className="py-3 px-4">
                  <code className="font-mono text-xs text-muted-foreground">
                    {prop.type}
                  </code>
                </td>
                <td className="py-3 px-4">
                  {prop.default ? (
                    <code className="font-mono text-xs">{prop.default}</code>
                  ) : (
                    <div className="text-muted-foreground">-</div>
                  )}
                </td>
                <td className="py-3 px-4 text-muted-foreground">
                  {prop.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SectionCard>
  );
}

export default PropsTable;
